// Readback verification is not atomic concurrency control: backend CAS is deferred.
export const UNVERIFIED_SAVE = 'The save could not be verified. Refresh this product and review its current values before retrying; it may already have saved.';
export function verifyProductSave(confirmed, intended, expectedId) {
  if (!confirmed?.id || (expectedId != null && confirmed.id !== expectedId) || confirmed.product_type !== intended.product_type) throw new Error(UNVERIFIED_SAVE);
  for (const field of ['price_minor', 'sale_price_minor', 'cost_minor']) {
    if (Object.prototype.hasOwnProperty.call(intended, field) && (confirmed[field] ?? null) !== (intended[field] ?? null)) throw new Error(UNVERIFIED_SAVE);
  }
  return confirmed;
}
export function variantPayloadFromFresh(product, variantId, original, field, value, expectedProductId) {
  if (expectedProductId != null && product?.id !== expectedProductId) throw new Error(UNVERIFIED_SAVE);
  const current = product?.variants?.find((item) => item.id === variantId);
  if (!current) throw new Error('This variant is no longer available. Refresh the product.');
  if ((current[field] ?? null) !== (original[field] ?? null)) throw new Error('This value changed since you opened it. Refresh and review before saving.');
  const draft = { ...current, [field]: value };
  return {
    name: draft.name, sku: draft.sku, barcode: draft.barcode || null,
    price_minor: draft.price_minor, sale_price_minor: draft.sale_price_minor ?? null,
    active: draft.active, track_inventory: draft.track_inventory,
    fulfillment_mode: draft.fulfillment_mode || product.fulfillment_mode || 'hybrid',
    reorder_threshold: draft.reorder_threshold || 0,
  };
}
export function verifyVariantSave(product, variantId, field, value, expectedProductId) {
  if (expectedProductId != null && product?.id !== expectedProductId) throw new Error(UNVERIFIED_SAVE);
  const current = product?.variants?.find((item) => item.id === variantId);
  const normalize = (v) => ['sku', 'barcode'].includes(field) && typeof v === 'string' ? v.trim().toUpperCase() : v;
  if (!current || normalize(current[field] ?? null) !== normalize(value ?? null)) throw new Error(UNVERIFIED_SAVE);
  return product;
}
